/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProgramaModelDto } from '../../models/programa-model-dto';

export interface ProgramasControllerEditarPrograma$Params {
  
    /**
     * Datos del programa a editar
     */
    body: ProgramaModelDto
}

export function programasControllerEditarPrograma(http: HttpClient, rootUrl: string, params: ProgramasControllerEditarPrograma$Params, context?: HttpContext): Observable<StrictHttpResponse<ProgramaModelDto>> {
  const rb = new RequestBuilder(rootUrl, programasControllerEditarPrograma.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProgramaModelDto>;
    })
  );
}

programasControllerEditarPrograma.PATH = '/api/programas/editar-programa';
